import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import InvoiceUpload from './InvoiceUpload';
import InvoiceList from './InvoiceList';
import InvoiceReview from './InvoiceReview';
import WorldPacPanel from './WorldPacPanel';
import OrdersList from './OrdersList';

export default function OpsOrdering() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [openId, setOpenId] = useState(null);
  const bump = () => setRefreshKey((k) => k + 1);

  return (
    <div className="space-y-6">
      <div className="bg-surface-card rounded-card shadow-elevation-1 border p-6">
        <h3 className="text-lg font-bold text-ink-soft flex items-center gap-2">
          <FileText className="w-5 h-5" /> Ordering &amp; Invoices
        </h3>
        <p className="text-ink-muted mt-1">Upload a supplier PDF invoice; it is parsed automatically for review.</p>
      </div>

      {openId ? (
        <InvoiceReview invoiceId={openId} onDone={() => { setOpenId(null); bump(); }} />
      ) : (
        <>
          <InvoiceUpload onUploaded={bump} />
          <InvoiceList refreshKey={refreshKey} onOpen={setOpenId} />
          <WorldPacPanel onSynced={bump} />
          <OrdersList refreshKey={refreshKey} />
        </>
      )}
    </div>
  );
}
